export default "__VITE_ASSET__DmVTH2d3__"